import { Typography } from '@mui/material';
import AILogoIcon from '../../../assets/icons/AI_logo.svg?react';
import { css } from '@emotion/react';
import { panelSurfaceCss } from './panelStyles';

/** Figma list body — rgba(12,29,48,0.9) */
const listText = 'rgba(12, 29, 48, 0.9)';

const panelCss = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px 16px;
  width: 100%;
`;

const headerRowCss = css`
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 24px;
`;

/** Figma fill/AI title — linear-gradient 163.214deg */
const titleGradientCss = css`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: 0.17px;
  background-image: linear-gradient(163.214deg, rgb(0, 172, 227) 35.025%, rgb(120, 102, 255) 69.241%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

const listCss = css`
  margin: 0;
  /* Figma li ms-[21px] — list inset for disc + text */
  padding: 0 0 0 21px;
  list-style-type: disc;
  list-style-position: outside;
  width: 100%;
  box-sizing: border-box;
`;

const listItemCss = css`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: 0.17px;
  color: ${listText};
`;

interface ForesightSummaryPanelProps {
  readonly summary: readonly string[];
}

export function ForesightSummaryPanel({ summary }: ForesightSummaryPanelProps) {
  return (
    <div css={[panelSurfaceCss, panelCss]}>
      <div css={headerRowCss}>
        <AILogoIcon width={24} height={24} aria-hidden />
        <Typography component='p' css={titleGradientCss}>
          Foresight Summary
        </Typography>
      </div>
      <ul css={listCss}>
        {summary.map((point) => (
          <li key={point} css={listItemCss}>
            {point}
          </li>
        ))}
      </ul>
    </div>
  );
}
